import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import Urlshortener from "../Url/Urlshortener";

const Layout = () => {
    return (
        <>
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Navbar />
                <main style={{ flex: "1" }}>
                    <Urlshortener />
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Layout;
